export default class ReportBuilderException extends Error {
    constructor(message, ...params) {
        super(...params);
        this.message = message;
        this.name = 'ReportBuilderException';
    }
}